import Dexie from 'dexie';
import moment from 'moment';

import { TAttachmentDB, TRoomMessageDB, TDirectMessageDB } from '../../types/db';

class DB extends Dexie {
  attachments: Dexie.Table<TAttachmentDB, string>;
  roomMessages: Dexie.Table<TRoomMessageDB, string>;
  directMessages: Dexie.Table<TDirectMessageDB, string>;

  constructor() {
    console.log('Called constructor DB');
    super('HILBI_DB');

    this.version(1).stores({
      attachments: '&id, type',
      roomMessages: '&id, from, sender, stamp, text, roomId',
      directMessages: '&uuid, body, from, to, stamp, thread, currentUserId, [thread+currentUserId]',
    });

    this.attachments = this.table('attachments');
    this.roomMessages = this.table('roomMessages');
    this.directMessages = this.table('directMessages');
  }

  public async getDailyMessages(jabberId: string, timestamp: Date | null): Promise<any> {
    const messages = await this.directMessages
      .where('from')
      .equals(jabberId)
      .or('to')
      .equals(jabberId);

    return await messages
      .filter((item) => {
        const reference = moment(timestamp);
        const date = moment(item.stamp);
        return reference.isSame(date, 'day');
      })
      .sortBy('stamp');
  }

  public async addDirectMessage(message: any) {
    this.directMessages.put(message, message.uuid);
  }
}

export default new DB();
